module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-5-sm-30a6fc322677956fface392f527ef98f.png";